<template>
  <v-container ma-0 pa-0>
    <v-layout justify-center row wrap>
      <v-flex xs12 ma-0 pa-0>
        <v-toolbar flat>
            <v-toolbar-side-icon></v-toolbar-side-icon>
            <v-toolbar-title>Admin Dashboard</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items class="hidden-sm-and-down">
              <v-btn flat>Club Records</v-btn>
              <v-btn flat>Stats</v-btn>
              <v-btn flat>Board</v-btn>
            </v-toolbar-items>
          </v-toolbar>
            <v-tabs
              v-model="active"
              slider-color="orange"
            >
              <v-tab key="1" ripple>Members</v-tab>
              <v-tab key="2" ripple>News</v-tab>
              <v-tab key="3" ripple>Emails</v-tab>
              <v-tab-item key="1">
                <v-card-title class="pb-0">
                   <v-toolbar card prominent>
                    <v-toolbar-title class="body-2 grey--text">
                      Search Name or Email
                      </v-toolbar-title>

                    <v-spacer></v-spacer>

                    <v-btn icon>
                      <v-icon>search</v-icon>
                    </v-btn>

                    <v-btn icon>
                      <v-icon>apps</v-icon>
                    </v-btn>

                    <v-btn icon>
                      <v-icon>more_vert</v-icon>
                    </v-btn>
                  </v-toolbar>
                </v-card-title>
                <v-card-text class="pt-0">
                  <v-layout row wrap justify-center>
                    <v-flex xs12 pa-0>
                      <v-list two-line subheader>
                        <v-list-tile
                          v-for="member in members"
                          :key="member.id"
                          avatar
                        >
                          <v-list-tile-avatar>
                            <v-avatar v-if="member.idImage" size="40px" large class="blue white--text">
                              <img :src=member.idImage>
                            </v-avatar>
                            <v-icon v-else large class="blue white--text">person</v-icon>
                          </v-list-tile-avatar>
                          <v-list-tile-content class="black-text">
                            <v-list-tile-title>{{ member.details.firstName }} {{ member.details.lastName }}</v-list-tile-title>
                            <v-list-tile-sub-title>{{ }}</v-list-tile-sub-title>
                          </v-list-tile-content>
                        </v-list-tile>
                      </v-list>
                    </v-flex>
                  </v-layout>
                </v-card-text>
              </v-tab-item>
              <v-tab-item key="2">
                <v-card-title>
                  <h1 class="headline">
                    Club News Articles
                  </h1>
                </v-card-title>
                <v-card-text>
                </v-card-text>
              </v-tab-item>
              <v-tab-item key="3">
                <v-card-title>
                  <h1 class="headline">
                    Club Emails
                  </h1>
                </v-card-title>
                <v-card-text>
                </v-card-text>
              </v-tab-item>
            </v-tabs>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import store from '@/store'
// import TestMemeberList from '@/data/TestAccountMembers'
import { mapGetters, mapActions } from 'vuex'

export default {
  computed: {
    user () {
      return store.state.user
    },
    ...mapGetters({
      members: 'getMembers'
    })
  },
  methods: {
    next () {
      const active = parseInt(this.active)
      this.active = (active < 2 ? active + 1 : 0)
    },
    ...mapActions([
      'getMembers'
    ])
  },
  data () {
    return {
      active: null
      // members: TestMemeberList
    }
  },
  mounted () {
    this.getMembers()
  }
}
</script>
<style>
  #specialOffer {
    font-size: 2rem;
    background-color: darkgreen;
    padding: 5px 20px;
    border-radius: 3px;
    width: fit-content;
    color: white;
  }
</style>
